


























































































































































































import { Component } from "vue-property-decorator";
import { Validate } from "vuelidate-property-decorators";
import { required, email } from "vuelidate/lib/validators";
import { i18n } from "@/resources/locales";
import { TIME_ZONE_EN } from "@/resources/constants/timeZone.en";
import { TIME_ZONE_ES } from "@/resources/constants/timeZones.es";
import { UserInterface } from "@/resources/interfaces/userInterfaces";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import ErrorController from "@/resources/mixins/errorController/errorController";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import ImageCropComponent from "@/app/components/imageCrop/imageCrop.component.vue";
import UserValidator from "@/resources/mixins/userValidator";
import { MAX_SIZE_FILE } from "@/resources/constants/system";
import moment from "moment";
import { LANGUAGES } from "@/resources/constants/userLanguages";
@Component({
  name: "profile-general-component",
  components: { ImageCropComponent, Cropper },
})
export default class GeneralComponent extends mixins(
  NotificationEvent,
  ErrorController,
  UserValidator
) {
  @Validate({ required })
  name = "";
  @Validate({ required, email })
  email = "";
  @Validate({ required })
  timezone = "";
  lastName = "";
  birthday = null;
  today = null;
  city = "";
  user!: UserInterface;
  timeZoneList = i18n.locale === "en" ? TIME_ZONE_EN : TIME_ZONE_ES;
  loading = false;
  loadingEmail = false;
  profileImage = [];
  filePreview = "";
  img = "";
  openCrop = false;
  constructor() {
    super();
    this.today = moment(new Date()).utc().format("yyyy-MM-DD");
    this.user = this.$store.getters["UserStore/getUser"];
    this.name =
      this.user.name && this.user.name !== "noname" ? this.user.name : "";
    this.lastName = this.user.lastName;
    this.birthday = moment(this.user.birthday).isValid()
      ? moment.utc(this.user.birthday).format("yyyy-MM-DD")
      : null;
    this.email = this.user.email;
    this.timezone = this.user.timezone != null ? this.user.timezone : "";
    this.city = this.user.city;
  }
  mounted() {
    setTimeout(() => {
      const select = document.getElementsByClassName("vs-select__input");
      const inputSelect = select[0];
      if (inputSelect instanceof HTMLInputElement) {
        inputSelect.placeholder = i18n.t("labels.search").toString();
      }
    }, 1000);
  }
  destroyed() {
    this.deleteTooltip();
  }
  get active() {
    return this.openCrop;
  }
  set active(e) {
    this.openCrop = e;
  }
  deleteTooltip() {
    const tooltip = document.getElementsByClassName("vs-tooltip");
    if (tooltip)
      while (tooltip.length > 0) {
        tooltip[0].parentNode.removeChild(tooltip[0]);
      }
  }
  onBoarding(): any {
    return this.$store.getters["SystemStore/getShowCompleteOnBoarding"];
  }
  updateUserEmail(): void {
    this.loadingEmail = true;
    this.$store.dispatch("UserStore/updateUserAction", {
      userId: this.user.id,
      props: {
        email: this.email,
      },
      callback: (user) => {
        this.loadingEmail = false;
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.userUpdate")
        );
        this.$store.dispatch("SpaceStore/updateUserInSpace", user);
      },
      callbackError: (error) => {
        this.loadingEmail = false;
        if (error.response && error.response.status == 422)
          this.checkError(error);
        else
          this.onError("", i18n.t("notifications.errorMessages.updatePerfil"));
      },
    });
  }
  updateUserData(): void {
    this.loading = true;
    this.$store.dispatch("UserStore/updateUserAction", {
      userId: this.user.id,
      props: {
        name: this.name,
        lastName: this.lastName,
        timezone: this.timezone,
        birthday: moment(this.birthday).isValid()
          ? moment(this.birthday).format("yyyy-MM-DD HH:mm:ss")
          : null,
        city: this.city,
      },
      callback: (user) => {
        if (this.profileImage.length > 0) {
          this.uploadFile();
        }
        this.loading = false;

        this.$store.dispatch("SpaceStore/updateUserInSpace", user);
        if (this.onBoarding()) {
          this.$emit("next");
        } else {
          this.onSuccess(
            i18n.t("notifications.titles.success"),
            i18n.t("notifications.descriptions.userUpdate")
          );
        }
      },
      callbackError: (error) => {
        this.loading = false;
        this.onError("", i18n.t("notifications.errorMessages.updatePerfil"));
      },
    });
  }
  selectFile(): void {
    this.localremoveImage();
    if (
      this.$refs.file["files"][0] &&
      this.$refs.file["files"][0].size >= MAX_SIZE_FILE
    ) {
      this.onError(
        this.$i18n.t("notifications.titles.error"),
        this.$i18n.t("notifications.errorMessages.maxFileSize")
      );
      return;
    }
    if (this.$refs.file["files"].length > 0) {
      this.profileImage = this.$refs.file["files"];

      this.active = true;
      this.openCrop = true;
      const fr = new FileReader();
      setTimeout(() => {
        const img = document.getElementById("preview-image");
        fr.onload = (event) => {
          if (event) {
            if (img instanceof HTMLImageElement) {
              this.filePreview = event ? event?.target.result.toString() : "";
              this.img = event ? event?.target.result.toString() : "";
            }
          }
        };
        fr.readAsDataURL(this.profileImage[0]);
      }, 200);
    }
  }
  uploadFile(): void {
    const formData = new FormData();
    if (this.profileImage) {
      formData.append("file", this.dataURItoBlob(this.filePreview) || "");
      this.$store.dispatch("UserStore/uploadUserProfileImageAction", {
        data: formData,
        callback: (response) => {
          this.loading = false;
          this.user.profileImage = response.data;
          this.$store.dispatch("UserStore/getUserAction", {
            callback: (response) => {
              this.user = this.$store.getters["UserStore/getUser"];
            },
          });
          /*if (!this.onBoarding()) {
            this.onSuccess(
              i18n.t("notifications.titles.success"),
              i18n.t("notifications.descriptions.userUpdate")
            );
          }*/
        },
        callbackError: (error) => {
          console.log("uploadFile callbackError ", error);
        },
      });
    }
  }
  dataURItoBlob(dataURI): Blob {
    const binary = atob(dataURI.split(",")[1]);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: "image/jpeg" });
  }
  localremoveImage() {
    this.profileImage = [];
    this.user.profileImage = null;
    this.filePreview = "";
    this.img = "";
  }
  async removeImage() {
    if (!this.user.profileImage) return;
    await this.$store.dispatch("UserStore/removeImageUserAction", {
      imageId: this.user.profileImage.id,
      callback: (response) => {
        this.profileImage = [];
        this.user.profileImage = null;
        this.deleteTooltip();
      },
      callbackError: (error) => {
        this.onError("", i18n.t("notifications.genericError.updateImage"));
      },
    });
  }
}
